"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromArray = exports.ASSIGNABLE = exports.UNASSIGNABLE = exports.ORDINARY = exports.SPECIAL = exports.ALL = void 0;
const roles_1 = require("./config/roles");
// list of all possible roles
exports.ALL = Object.values(roles_1.Role);
// these roles are 'special' internal roles that can't be set for users
// using the normal type templates system - they are set by logic instead
exports.SPECIAL = [
    roles_1.Role.ROTA_ADMIN,
    roles_1.Role.ROTA_AGENT,
    roles_1.Role.ROTA_SISENSE_ADMIN,
    roles_1.Role.ROTA_SISENSE_EMBED,
    roles_1.Role.REQUESTER,
    roles_1.Role.PROVIDER,
    roles_1.Role.SCHEDULER,
    roles_1.Role.PROVIDER_SCHEDULER,
    roles_1.Role.ETC,
    roles_1.Role.EVOLVE,
    roles_1.Role.TIMESHEETS_48HR_RULE_DISABLED,
];
// these roles the set in use for normal user type templates
exports.ORDINARY = exports.ALL.filter((r) => !exports.SPECIAL.includes(r));
// these roles can never be assigned to custom type templates
exports.UNASSIGNABLE = [
    roles_1.Role.ROTA_ADMIN,
    roles_1.Role.ROTA_AGENT,
    roles_1.Role.ROTA_SISENSE_ADMIN,
    roles_1.Role.ROTA_SISENSE_EMBED,
    roles_1.Role.TYPE_TEMPLATES,
    roles_1.Role.TYPE_TEMPLATE_CREATE,
    roles_1.Role.TYPE_TEMPLATE_EDIT,
    roles_1.Role.TYPE_TEMPLATE_ASSIGN,
    roles_1.Role.USER_DELETE,
];
// these roles can be assigned to custom type templates
exports.ASSIGNABLE = exports.ORDINARY.filter((r) => !exports.UNASSIGNABLE.includes(r));
const fromArray = (rolesArray) => exports.ALL.filter((role) => rolesArray.includes(role));
exports.fromArray = fromArray;
